export default __webpack_public_path__ + "static/media/heirs-burglary-02.743211df.png";